/* mw-search: busca preditiva via Section Rendering API (/search/suggest).
   O dropdown e renderizado em Liquid (sections/predictive-search.liquid);
   JS so busca e injeta. Fallback sem JS: form GET /search. */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-mw-search]');
  if (!wrap) return;
  var input = wrap.querySelector('[data-mw-search-input]');
  var caixa = wrap.querySelector('[data-mw-search-resultados]');
  if (!input || !caixa) return;
  var t = null;

  function fecharCaixa() {
    caixa.setAttribute('hidden', '');
    wrap.setAttribute('aria-expanded', 'false');
  }

  function buscar(q) {
    fetch(
      '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search'
    )
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var conteudo = tmp.querySelector('[data-mw-predictive]');
        if (!conteudo) return;
        caixa.innerHTML = conteudo.innerHTML;
        caixa.removeAttribute('hidden');
        wrap.setAttribute('aria-expanded', 'true');
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(t);
    var q = input.value.trim();
    if (!q) { fecharCaixa(); return; }
    t = setTimeout(function () { buscar(q); }, 250);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { fecharCaixa(); input.blur(); }
    if (e.key === 'ArrowDown') {
      var primeiro = caixa.querySelector('a');
      if (primeiro) { e.preventDefault(); primeiro.focus(); }
    }
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) fecharCaixa();
  });
})();
